<h4 matDialogTitle>Configure {{ type$ | async | titlecase }}</h4>
<div matDialogContent>
  <mat-horizontal-stepper linear #stepper>
    <mat-step>
      <ng-template matStepLabel>Account Mappings</ng-template>
      <ng-template matStepContent>
        <p>
          Use the dropdowns below to select the account on
          {{ type$ | async | titlecase }} that the respective HireLogic
          transactions should map to.
        </p>
        <generic-account-mapping
          (newFormGroup)="setAccountMappingForm($event)"
        ></generic-account-mapping>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>Tax Mappings</ng-template>
      <ng-template matStepContent>
        <p>
          Use the dropdowns below to select the tax rates on
          {{ type$ | async | titlecase }} that the respective HireLogic
          transactions should map to.
        </p>
        <generic-tax-mappings
          (newFormGroup)="setTaxMappingForm($event)"
        ></generic-tax-mappings>
      </ng-template>
    </mat-step>
  </mat-horizontal-stepper>
</div>
<div
  matDialogActions
  fxLayout="row"
  fxLayoutAlign="end center"
  fxLayoutGap="8px"
>
  <button mat-raised-button (click)="dialogRef.close()" type="button">
    Cancel
  </button>
  <button
    mat-raised-button
    [disabled]="!accountMappingForm?.valid"
    color="primary"
    id="save-config"
    type="submit"
    (click)="save()"
  >
    Save {{ stepper.selectedIndex === 0 ? 'Accounts' : 'Tax' }}
    Mappings
  </button>
</div>
